import styled from "@emotion/styled";

export const ParallaxContainer = styled.div<{ type?: 'hero' | 'visit' }>`
    position: relative;
    height: ${props => props.type === 'hero' ? '100vh' : '60vh'};
    min-height: ${props => props.type === 'hero' ? '500px' : '400px'};
    overflow: hidden;
    perspective: 1px;
    transform-style: preserve-3d;
    margin-top: -64px;
`;

export const ParallaxVideo = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateZ(-1px) scale(2);
    z-index: -1;
    overflow: hidden;
`;

export const OverlayContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    width: 90%;
    max-width: 800px;
    text-align: center;
`;

export const TitleBox = styled.div`
    background: rgba(255, 255, 255, 0.9);
    padding: 1rem 2rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const VerseContainer = styled.div`
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    font-style: italic;
    font-size: 1.25rem;
    line-height: 1.6;
    max-width: 600px;
`;
